export const emailReg = /^.+@.+\..{2,24}$/;

export const REQUIRED = 'required';
export const INVALID_EMAIL = 'invalid_email_address';
export const MUST_BE_THE_DIFFERENCE = 'must_be_the_difference';
export const MAX_ALLOWED_180_DAYS = 'max_180_days';
export const MUST_BE_POSITIVE = 'must_be_positive';
